export const USED_AS_SPA = "false" === 'true';
export const SENTRY_DSN = "https://53483e5aeaf54b5092e4a7b16898a9b6@sentry.io/1417687" || '';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SPLIT_IO_API_KEY_STAGING = "n33vr9vfs09671pc90pgi7kvj8q7vvvfvjvd";
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SPLIT_IO_API_KEY_PRODUCTION = "9a44abjpf5r66aq6r9o6426v9n2tg9ko9tah";
export default environment => {
  switch (environment) {
    case 'PRODUCTION':
      return {
        SPLIT_IO_API_KEY: SPLIT_IO_API_KEY_PRODUCTION,
        urls: {
          CAMPUS_API: 'https://campus-api.datacamp.com',
          MAIN_APP: 'https://www.datacamp.com',
          TEACH_APP: 'https://teach-api.datacamp.com/teach-app'
        }
      };
    case 'LOCAL':
    case 'DEVELOPMENT':
    case 'TEST':
    case 'STAGING':
    default:
      return {
        SPLIT_IO_API_KEY: SPLIT_IO_API_KEY_STAGING,
        urls: {
          CAMPUS_API: 'https://campus-api.datacamp-staging.com',
          MAIN_APP: 'https://www.datacamp-staging.com',
          TEACH_APP: 'https://teach-api.datacamp-staging.com/teach-app'
        }
      };
  }
};